import API from './axiosConfig';

// Get all activities
export const getActivities = async () => {
  try {
    const response = await API.get('/activities');
    console.log("Activities API response:", response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error("Error fetching activities:", error);
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    throw error;
  }
};

// Get activities by project ID
export const getActivitiesByProjectId = async (projectId) => {
  try {
    const response = await API.get(`/activities/project/${projectId}`);
    return response.data.data || response.data;
  } catch (error) {
    console.error("Error fetching activities by project:", error);
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    throw error;
  }
};

// Create a new activity
export const createActivity = async (activityData) => {
  try {
    const response = await API.post('/activities', activityData);
    return response.data.data || response.data;
  } catch (error) {
    console.error("Error creating activity:", error);
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    throw error;
  }
};

// Update an activity
export const updateActivity = async (activityId, activityData) => {
  try {
    const response = await API.put(`/activities/${activityId}`, activityData);
    return response.data.data || response.data;
  } catch (error) {
    console.error("Error updating activity:", error);
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    throw error;
  }
};

// Delete an activity
export const deleteActivity = async (activityId) => {
  try {
    const response = await API.delete(`/activities/${activityId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting activity:", error);
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    throw error;
  }
};